import { CheckoutBreakdownTypeEnum } from 'src/core/model/enum/checkout-breakdown-type.enum';
import { CheckoutModel } from 'src/core/model/quarter-overview.model';

export const DRAWER_MENU_WIDTH = 240;

export const I18N_DEFAULT_NS = 'translation';

export const OCPI_FILTERABLE_FIELDS: string[] = [
  'sessionId',
  'cdrId',
  'locationId',
  'evseId',
  'evseUid',
  'connectorId',
  'commandId',
  'eventName',
];
export const OCPI_FILTERABLE_FIELD_KEY = 'ocpiFilter';

export const UTF8_BOM = new Uint8Array([0xef, 0xbb, 0xbf]);
export const CSV_MIME_TYPE = 'text/csv';
export const DELMONICOS_QUARTER_OVERVIEW_EXTERNAL_ID_CARD = 'FR-DLM';

export const LMS_COLUMNS = {
  id: 'ID',
  date: 'Date',
  chargePointName: 'Borne de charge',
  connectorId: 'Point de charge',
  customerId: 'ID client',
  name: 'Nom',
  externalCardId: 'ID carte externe',
  internalCardId: 'ID carte interne',
  global: 'Glob.',
  energyDelivered: 'Energie (kWh)',
  totalHT: 'Prix HT',
  durationInMin: 'Durée (min)',
};

export const CHECKOUT_COLUMNS: Record<keyof CheckoutModel, string> = {
  breakdownType: 'Breakdown Type',
  iTransactionId: 'Reference',
  totalHT: 'Holding Currency Amount',
};

export const TIME_RESTRICTION_FORMAT = 'HH:mm';

export const IGNORED_CHECKOUT_BREAKDOWN_TYPE: CheckoutBreakdownTypeEnum[] = [
  CheckoutBreakdownTypeEnum.PAYOUT,
  CheckoutBreakdownTypeEnum.CAPTURE,
  CheckoutBreakdownTypeEnum.PARTIAL_CAPTURE,
];

export const MAX_AUTOCOMPLETE_SELECT_OPTIONS = 30;
export const MIN_SEARCH_CHARACTERS = 2;

export const TABLE_LIMIT_OPTION_MIN = 25;
export const TABLE_LIMIT_OPTION_PITCH = 25;
export const TABLE_LIMIT_OPTION_COUNT = 4;
export const TABLE_LIMITS_OPTIONS = new Array(TABLE_LIMIT_OPTION_COUNT)
  .fill(0)
  .map((_, i) => TABLE_LIMIT_OPTION_MIN + TABLE_LIMIT_OPTION_PITCH * i);
